import { getModule } from 'vuex-module-decorators';

import { StoreSingleton } from '.';
import PaginationStore from './pagination.module';

export const paginationStore = getModule<PaginationStore>(PaginationStore, StoreSingleton.getInstance());
